import { render, staticRenderFns } from "./validation-list.vue?vue&type=template&id=52b6d250"
import script from "./validation-list.vue?vue&type=script&lang=js"
export * from "./validation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports